import axios from 'axios'
import {uriConstants} from "../constants";

export const certificateService = {
  openKcmPopUp,
  openIpinPopUp,
  createCrtfSubmit,
  createCrtfUpload,
  createCrtfReading,
  verifyCertificate,
  openPccPopUp
}

async function openKcmPopUp(viewAddr) {

  const formData = new FormData()

  formData.set('viewAddr', viewAddr ? viewAddr : 'privateca')
  formData.set('joinType', '01')
  formData.set('menuId', '0')
  formData.set('tmp', 16007849459)

  return await axios.post(
    'https://paperless-dev.apwisdom.com/swg/common/kmcSendParam.do',
    'viewAddr=certUser' +
    '&joinType=01' +
    '&menuId=0' +
    '&tmp=1596596083378'
    // formData
  )
}

async function openIpinPopUp(viewAddr) {

  const formData = new FormData()

  formData.set('viewAddr', viewAddr ? viewAddr : 'privateca')
  formData.set('joinType', '01')
  formData.set('menuId', '0')
  formData.set('tmp', 16007849459)

  return await axios.post(
    'https://paperless-dev.apwisdom.com/swg/common/ipinPopUp.do',
    'viewAddr=certUser' +
    '&joinType=01',
    formData
  )
}

async function createCrtfSubmit(params) {
  const formData = new FormData()

  // setFormData(formData, params.receiver, 'receiver');

  formData.append('crtSeqs', params.crtSeq);
  formData.append('ewalletIds', params.ewalletIds);

  let files = params.files?.filter(function (item) {
    return item !== null && item !== undefined;
  });

  files.forEach(file => {
    formData.append('files', file.docFile, file.docFile.name);
  })

  const user = JSON.parse(localStorage.getItem('user'));

  return await axios.post(
    uriConstants.API_URI + uriConstants.SUBMIT_CERTIFICATE,
    formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + user?.payload?.accessToken
      }
    })
}

async function createCrtfUpload(params) {
  const formData = new FormData()

  // setFormData(formData, params.receiver, 'receiver');

  formData.append('crtSeqs', params.crtSeq);
  formData.append('contentIds', params.contentIds);

  let files = params.files?.filter(function (item) {
    return item !== null && item !== undefined;
  });

  files.forEach(file => {
	if(file.docYn === 'N'){
    	formData.append('files', file.docFile, file.docFile.name);
	}
  })

  const user = JSON.parse(localStorage.getItem('user'));
  return await axios.post(
    uriConstants.API_URI + uriConstants.UPLOAD_CERTIFICATE,
    formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + user?.payload?.accessToken
      }
    })
}

async function createCrtfReading(params) {
  const formData = new FormData()

  // setFormData(formData, params.receiver, 'receiver');

  formData.append('crtSeqs', params.crtSeq);
  formData.append('mailList', params.mailList);

  const user = JSON.parse(localStorage.getItem('user'));

  return await axios.post(
    uriConstants.API_URI + uriConstants.READING_CERTIFICATE,
    formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + user?.payload?.accessToken
      }
    })
}

async function verifyCertificate(params) {
  const formData = new FormData();
  
  if(params.file === undefined) {
    formData.append('file2', '');
  }else {
    formData.append('file', params.file, params.name);
  }
  formData.append('crtSeq', params.crtSeq);
  formData.append('crtRcvSeq', params.crtRcvSeq);
  formData.append('fileGroupId', params.fileGroupId);

  const user = JSON.parse(localStorage.getItem('user'));
  let token = user?.payload?.accessToken
  let sendUri = uriConstants.VERIFY_CERTIFACATE
  if(!user?.payload?.accessToken && params.file){
    sendUri = uriConstants.VERIFY_CERTIFACATE_NOT_MEMBER
  }
  return await axios.post(
    uriConstants.API_URI + sendUri,
    formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + user?.payload?.accessToken
      }
    })
}
async function openPccPopUp() {

  

  
  return await axios.post(
    'https://paperless-dev.apwisdom.com/swg/common/kmcSendParam.do',
    'viewAddr=certUser' +
    '&joinType=01' +
    '&menuId=0' +
    '&tmp=1596596083378'
    // formData
  )
}

// function setFormData(formData, data, parentKey) {
//   if (!(formData instanceof FormData)) return;
//   if (!(data instanceof Object)) return;
//   Object.keys(data).forEach(key => {
//     const val = data[key];
//     if (parentKey) key = `${parentKey}[${key}]`;
//
//     if (val instanceof Object && !Array.isArray(val)) {
//       return setFormData(formData, val, key);
//     }
//
//     if (Array.isArray(val)) {
//       val.forEach((v, idx) => {
//         if (v instanceof Object) {
//           setFormData(formData, v, `${key}[${idx}]`);
//         } else {
//           formData.append(`${key}[${idx}]`, v);
//         }
//       });
//     } else {
//       formData.append(key, val);
//     }
//   });
// }
